//Vue and associated pieces
import Vue from 'vue';
import Buefy from 'buefy';
import VueGtag from "vue-gtag";
import inEU from '@segment/in-eu'

import store from './store';
import router from "./routes";
import App from "./App";
import {setVueInstance} from "buefy/src/utils/config";
import axios from "axios";

Vue.use(Buefy, {
    defaultIconPack: 'fas',
});
setVueInstance(Vue);

Vue.component('app', App);

Vue.use(VueGtag, {
        config: {
            id: 'UA-48125195-3',
            params: {
                anonymizeIp: inEU(),
                cookie_flags: 'SameSite=None;Secure',
            }
        },
        enabled: inEU() ? localStorage.getItem("vue-cookie-accept-decline-heat-tracking") === 'accept' : true,
    },
    router
);

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

window.app = new Vue({
    el: '#app',
    store,
    router,
});
